var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from 'react';
import { getImageUrl } from '@shared/utils/images';
import { hasDiscounts } from '@shared/utils/currency';
import PriceTag from '@shared/molecules/PriceTag';
import DiscountBadgeMedium from 'molecules/DiscountBadgeMedium';
import { Wrapper, ThumbnailImage, ImageWrapper, Bold, InfoWrapper, ActionWrapper, } from './styles';
var SliderArticleExtended = /** @class */ (function (_super) {
    __extends(SliderArticleExtended, _super);
    function SliderArticleExtended() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SliderArticleExtended.prototype.render = function () {
        var _a = this.props, article = _a.article, session = _a.session;
        var brand = article.brand, displayName = article.displayName, id = article.id, images = article.images, prices = article.prices, targetPrices = article.targetPrices;
        return (_jsx(Wrapper, { children: _jsxs(ActionWrapper, __assign({ to: "/" + session.uuid + "/articles/" + id }, { children: [_jsxs(ImageWrapper, { children: [_jsx(ThumbnailImage, { src: getImageUrl(images.main) }, void 0), hasDiscounts(prices, targetPrices) && (_jsx(DiscountBadgeMedium, { alignLeft: true }, void 0))] }, void 0), _jsxs(InfoWrapper, { children: [brand.name, displayName && " \u2013 " + displayName, _jsx(Bold, { children: _jsx(PriceTag, { prices: prices, targetPrices: targetPrices }, void 0) }, void 0)] }, void 0)] }), void 0) }, void 0));
    };
    return SliderArticleExtended;
}(Component));
export default SliderArticleExtended;
